<script>
import {  
  cloneDeep, 
  uniqueIdGenerator
} from '@/utils/tools'
import BuyShippingPopup from './BuyShippingPopup'
export default {
  name: 'EditBuyShippingPopup',
  mixins: [
    BuyShippingPopup
  ],
  data () {
    return {
      isEdit: true
    }
  },
  props: {
    editSelectedItems: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  mounted () {
    let initOrders = {} 
    this.editSelectedItems.forEach(item => {
      const { label, shipment } = item
      const order = this.selectedOrders.find(order => order._key === item.orderId)
      const orderId = order.orderId
      if (!order) {
        // alert('cant find this order, please create shipment by other order')
        throw Error('cant find this order, please create shipment by other order')
      }
      initOrders[orderId] = cloneDeep(order)
      const distribution = shipment.products[0]
      Object.assign(initOrders[orderId], {
        items: order.items.map((item, index) => { 
          const distribution = shipment.products[index]
          return {
            ...item, 
            toShip: item.quantityPurchased, 
            selectedDistribution: {
              ...distribution,
              shipmentProductKey: `${distribution.warehouseSite}${distribution.id}`
            }
          } 
        }),
        isOz: false,
        packaging: label.packaging,
        insuredValue: label.insuredValue || 0,
        senderName: label.from.fullName,
        fromCompanyName: label.from.company,
        shipDate: label.shipDate,
        isExpedited: shipment.isExpedited,
        selectedOtherServices: shipment.otherServices || [],
        signature: label.signature,
        shippingService: label.shippingService,
        carrier: label.carrier,
        template: {},
        templateInEdit: {},
        instruction: shipment.instruction || '',
        to: label.to,
        replacedMemo: label.memo || '',
        memo: label.memo || '',
        dangerousGoods: label.dangerousGoods || '',
        hazMatsInfo: label.hazMatsInfo || [],
        offerorName: label.offerorName || '',
        emergencyContactNumber: label.emergencyContactNumber || '',
        dryIceDetail: label.dryIceDetail || {
          weight: '',
          unit: ''
        },
        labelStockType: label.labelStockType || 'STOCK_4X6',
        isSupportHazmat: label.isSupportHazmat,
        packageTotal: shipment.packageQty,
        weightLbTotal: label.weight,
        referenceName: label.referenceName || '',
        referenceValue: label.referenceValue || '',
        packageType: label.packagingType,
        isOneRate: label.isOneRate,
        weightLb: label.weight,
        // ...label,
        shipFrom: label.from,
        isMPS: label.isMPS,
        isMeasurementMetric: label.isMeasurementMetric,
        isApiOrder: label.isApiOrder,
        toShip: shipment.orderChange[order.items[0].sku].fulfillQty,
        selectedDistribution: {
          ...distribution,
          shipmentProductKey: `${distribution.warehouseSite}${distribution.id}`
        },
        shipmentTaskId: item._key,
        buyerCompany: label.to.company,
        buyerEmail: label.to.email,
        buyerName: label.to.fullName,
        recipientName: label.to.fullName,
        shipAddress1: label.to.address1,
        shipAddress2: label.to.address2,
        shipCity: label.to.city,
        shipPostalCode: label.to.zipCode,
        shipState: label.to.state,
        buyerPhoneNumber: label.to.phone,
        toCompanyName: label.to.company
      })
      
      this.referenceOptions.forEach(item => {
        const val = label.packages[0][item.value]
        if (val && !initOrders[orderId].referenceName) {
          initOrders[orderId].referenceName = item.value
          initOrders[orderId].referenceValue = val
        }
      })
      // order.isMPS && (initOrders[order.orderId].packagingSpecs = order.packagingSpecs?.map(pkg => {
      //   return {
      //     ...pkg, 
      //     ...this.convertPackagingSize(pkg, order.isMeasurementMetric),
      //     weight: this.convertWeight(pkg.weight, order.isMeasurementMetric)
      //   }
      // }) || [])
    })
    this.$nextTick(() => {
      this.orders = initOrders
      Object.values(this.orders).forEach((order) => {
        this.shippingServiceOnChange(order)
        this.$watch(
          () => order, 
          function (val) {
            this.$set(this.errorMessages, order.orderId, '')
            this.$set(this.warningMessages, order.orderId, '')
            if (!Object.values(this.errorMessages).some(item => item)) {
              this.$refs.form.clearAlert()
            }
            order.replacedMemo = this.flexibleVars.reduce((acc, variable) => {
              if (variable === 'quantity') {
                return acc.replace(new RegExp(`#{${variable}}`, 'g'), order.toShip || 0)
              }
              return acc
            }, order.memo || '')
            if (!this.isSupportLabelStockType(order.shippingService)) {
              order.labelStockType = 'STOCK_4X6'
            }

            const { shippingService } = val
            if (shippingService) {
              const currentService = this.shippingServices.find(item => item.value === shippingService)
              order.isOneRate = currentService?.isOneRate
              if (order.isOneRate) {
                order.packageQuantity = 1
              }
            }
          },
          { deep: true }
        )
      })
      this.keywords = this.editSelectedItems[0].label.keywords
      // this.autoSelectDistribution()
    })
  },
  methods: {
    async onSubmitted () {
      this.isLoading = true
      let labels
      try {
        this.checkAllDistribution()
        const originOrderQty = Object.keys(this.orders).length
        const validatedOrderKeys = Object.keys(this.orders)
          .map(orderId => {
            const relatedFormKeys = Object.keys(this.$refs).filter(item => item.startsWith(`form-${orderId}`))
            const validateResults = relatedFormKeys.map(key => this.$refs[key].validate?.() || this.$refs[key][0]?.validate?.())
            if (validateResults.some(item => !item)) return ''
            return orderId
          })
          .filter(orderId => !!orderId)
        if (validatedOrderKeys.length < originOrderQty) throw Error(`Note: Please check errors.`)

        const randomIds = uniqueIdGenerator(validatedOrderKeys.length)
        const errorItems = []
        labels = validatedOrderKeys.map((orderId, index) => {
          let order = this.orders[orderId]
          const {items, toShip, storeId = '', storeName = '', platform} = order
          const requestId = order.requestId || (randomIds[index] + `A${this.randomNumGenerator(2)}`)
          const shipmentId = requestId.split('A')[0]
          try {
            const payload = this.extractLabelPayload(order)
            const res = {
              ...payload,
              requestId,
              shipmentId,
              isMPS: order.isMPS || false,
              isApiOrder: order.isApiOrder || false,
              orderKey: order._key,
              keywords: this.keywords,
              shipmentTaskId: order.shipmentTaskId,
              order: {
                orderId, 
                items: items.map(({ selectedDistribution, toShip, ...rest }) => {
                  return rest
                }), 
                toShip,
                storeId,
                storeName,
                platform
              }
            }
            if (res.isApiOrder && order.platform?.toUpperCase() === 'TIKTOK') {
              // single item
              const { items, toShip } = order
              if (toShip !== items[0].quantityPurchased) {
                errorItems.push(orderId)
              }
            }
            return res
          } catch (error) {
            this.$set(this.errorMessages, orderId, error.message)
            throw Error(`Note: Please check remaining orders' error.`)
          }
        })
        
        if (errorItems.length) {
          errorItems.forEach(item => {
            this.$set(this.errorMessages, item, `If you need partial delivery, please split the order first.`)
          })
          throw Error(`Note: Please check remaining orders' error.`)
        }

        await this.$store.dispatch('editOrderShipmentTask', {
          labels, 
          shipments: labels.map(label => {
            const orderId = label.orderKey.split('-').slice(1).join('-')
            return {
              ...this.extractShipmentPayload(this.orders[orderId]), 
              _key: label.shipmentId,
              shipmentTaskId: label.shipmentTaskId
            }
          }),
          keywords: this.keywords
        })

        this.$emit('submitted')
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        if (error.message === 'endpoint-request-timed-out') {
          labels && (labels.forEach(label => {
            const {requestId, orderKey} = label
            const orderId = orderKey.split('-').slice(1).join('-')
            this.orders[orderId].requestId = requestId
          }))
          
          throw Error('Endpoint request timed out. Please retry.')
        } else if (error.message === 'Package 1 - Invalid number of commodities in hazardous commodity content') {
          throw Error(this.$t('invalidNumberOfHazmat'))
        } 
        throw error
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditBuyShippingPopup.vue